import { Button, FloatButton, Form } from "antd";
import { FormInstance } from "antd/lib";
import { IntelligenceFormFieldsEnum } from "../enum";
import { generateQuestionElementId } from "../list";

import React from "react";
import { MenuOutlined } from "@ant-design/icons";

export const ControlQuestionFloat: React.FC<{
    form: FormInstance;
    onQuestionHighlight?: (questionId: string) => void;
}> = ({ form, onQuestionHighlight }) => {
    const [showList, setShowList] = React.useState(false);
    const questions: any[] = Form.useWatch(IntelligenceFormFieldsEnum.QUESTIONS, form);

    const scrollToQuestion = (questionId?: string) => {
        if (questionId === null || questionId === undefined) return;

        const element = document.getElementById(generateQuestionElementId(questionId));

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });

            setTimeout(() => {
                element.classList.add("question-highlight");

                onQuestionHighlight?.(questionId);

                setTimeout(() => {
                    element.classList.remove("question-highlight");
                }, 1500);
            }, 0); // Wait for scroll to complete
        }
    };

    if (!questions || questions?.length === 0) return null;

    return (
        <FloatButton.Group
            open={showList}
            style={{
                bottom: 160,
                zIndex: 10,
                right: 10,
            }}
            trigger="click"
            shape="square"
            icon={<MenuOutlined />}
            onClick={() => setShowList(!showList)}
            placement="left"
        >
            <div className="bg-white rounded-[10px] overflow-hidden flex flex-col items-start max-w-[200px]">
                {questions?.map((question) => (
                    <Button
                        type="text"
                        key={question?.question_id}
                        onClick={() => {
                            scrollToQuestion(question?.question_id);
                            setShowList(false); // Close menu after click
                        }}
                        className="w-full flex justify-start"
                    >
                        <span className="max-w-full truncate">{question?.question_name}</span>
                    </Button>
                ))}
            </div>
        </FloatButton.Group>
    );
};
